/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ImportJobMetadataFromJSON, ImportJobMetadataToJSON, ImportJobSourceFromJSON, ImportJobSourceToJSON, ImportJobStatusFromJSON, ImportJobStatusToJSON, } from './';
export function CreateImportJobRequestFromJSON(json) {
    return CreateImportJobRequestFromJSONTyped(json, false);
}
export function CreateImportJobRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        title: json['title'],
        description: !exists(json, 'description') ? undefined : json['description'],
        status: !exists(json, 'status') ? undefined : ImportJobStatusFromJSON(json['status']),
        metadata: ImportJobMetadataFromJSON(json['metadata']),
        source: ImportJobSourceFromJSON(json['source']),
        labels: !exists(json, 'labels') ? undefined : json['labels'],
    };
}
export function CreateImportJobRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        title: value.title,
        description: value.description,
        status: ImportJobStatusToJSON(value.status),
        metadata: ImportJobMetadataToJSON(value.metadata),
        source: ImportJobSourceToJSON(value.source),
        labels: value.labels,
    };
}
